import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowLeft, Calendar } from 'lucide-react';
import Footer from '../components/Footer';
import { getNewsItem } from '../lib/api';
import RsvpForm from '../components/RsvpForm';
import { isPast } from '../lib/events';

export default function NewsDetailPage() {
  const { id } = useParams();
  const [n, setN] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    getNewsItem(id).then(setN).catch(() => setNotFound(true));
  }, [id]);

  if (notFound) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-[#f8f6f2] px-6">
        <p className="font-serif-ah text-[32px] text-[#555] mb-4">Article not found.</p>
        <Link to="/news" className="btn-ah-solid font-sans-ah text-[13px] px-8 py-3.5 rounded-sm">BACK TO NEWS</Link>
      </div>
    );
  }
  if (!n) return <div className="min-h-screen bg-[#f8f6f2] animate-pulse" />;

  return (
    <>
      <section className="relative h-[52vh] min-h-[420px] flex items-end overflow-hidden">
        <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${n.image})` }} />
        <div className="absolute inset-0 bg-gradient-to-t from-[#1f2c33] via-[#1f2c33]/40 to-transparent" />
        <div className="relative z-10 max-w-[860px] mx-auto px-6 lg:px-10 w-full pb-12">
          <span className="inline-block bg-[#4a9cd4] text-white font-sans-ah text-[10px] tracking-wide-ah px-3 py-1.5 rounded-sm mb-4">{n.tag}</span>
          <h1 className="font-serif-ah text-white text-[38px] md:text-[54px] leading-tight">{n.title}</h1>
          <p className="flex items-center gap-2 font-sans-ah text-[13px] text-white/80 mt-4"><Calendar size={15} /> {n.date}</p>
        </div>
      </section>
      <article className="bg-[#f8f6f2] py-16 md:py-20">
        <div className="max-w-[760px] mx-auto px-6 lg:px-10">
          <Link to="/news" className="inline-flex items-center gap-2 font-sans-ah text-[12px] tracking-wide-ah text-[#4a9cd4] mb-8"><ArrowLeft size={15} /> ALL NEWS</Link>
          <p className="font-serif-ah text-[22px] text-[#3a3a3a] font-300 leading-relaxed mb-8 italic">{n.excerpt}</p>
          <div className="font-sans-ah text-[16px] text-[#454545] font-300 leading-[1.9] whitespace-pre-line">{n.body}</div>
          {/event/i.test(n.tag || '') && (
            <div className="mt-14 bg-white rounded-sm p-8 md:p-10 shadow-[0_10px_50px_rgba(0,0,0,0.07)] border border-neutral-100">
              {isPast(n.date)
                ? <p data-testid="rsvp-closed" className="font-serif-ah text-[22px] text-[#555] text-center py-6">This event has already taken place. RSVPs are closed.</p>
                : <RsvpForm eventId={n.id} eventTitle={n.title} />}
            </div>
          )}
        </div>
      </article>
      <Footer />
    </>
  );
}
